// Screen size comparison over navigator so it's testable on desktop
const isMobile = () =>
  window.Cypress
    ? false
    : Math.min(window.screen.width, window.innerWidth) < 768;

export default isMobile;
